import React from 'react';

import { RecursiveMenuMaxMenu } from '@uncinc/react-drupal-core';
import type { RecursiveMenuMaxMenuProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

import './style.scss';

export type MaxMenuProps = Pick<RecursiveMenuMaxMenuProps, 'menuId' | 'className' | 'onClickFunction'>;

const MaxMenu: React.FC<MaxMenuProps> = (props) => {
  const { menuId, className, onClickFunction } = props;

  return (
    <RecursiveMenuMaxMenu
      menuId={menuId}
      className={className}
      menuItemWrapperWrapperClasses="col-6 offset-1"
      linkIconName="arrow_forward"
      linkIconFlair="filled"
      onClickFunction={onClickFunction}
    />
  );
};

export default MaxMenu;
